import React from 'react';

import SimpleContainer from '../containers/simplecontainer/SimpleContainer';
import CategoryContainer from '../containers/categorycontainer/CategoryContainer';

import backgroundImage from '../media/press-kit.jpeg';

import logo144Horizontal from '../media/logos/aircheckr/144dpi/aircheckr-hor.png';
import logo144HorizontalNegative from '../media/logos/aircheckr/144dpi/aircheckr-hor-negatief.png';
import logo144picto from '../media/logos/aircheckr/144dpi/aircheckr-pictogramme.png';
import logo300Horizontal from '../media/logos/aircheckr/300dpi/aircheckr-hor.png';
import logo300Square from '../media/logos/aircheckr/300dpi/aircheckr-square.png';
import logo300picto from '../media/logos/aircheckr/300dpi/aircheckr-pictogramme.png';
import logoSvgHorizontal from '../media/logos/aircheckr/svg/aircheckr-hor.svg';
import logoSvgSquare from '../media/logos/aircheckr/svg/aircheckr-square.svg';
import logoSvgpicto from '../media/logos/aircheckr/svg/aircheckr-pictogramme.svg';
import nazkaTeamOne from '../media/nazka-team-1.jpg';
import nazkaTeamOneThumb from '../media/nazka-team-1_thumb.jpg';
import nazkaTeamTwo from '../media/nazka-team-2.jpg';
import nazkaTeamTwoThumb from '../media/nazka-team-2_thumb.jpg';
import aircheckrOnPhone from '../media/phone.png';
import aircheckrOnPhoneThumb from '../media/phone_thumb.png';
import aircheckrWidget300 from '../media/aircheckr-widget_nl_300dpi.png';
import aircheckrWidget96 from '../media/aircheckr-widget_nl_96dpi.png';
import aircheckrWidgetThumb from '../media/aircheckr-widget_nl_thumb.png';

import 'bootstrap/dist/css/bootstrap.css';

import { PageText, Categories } from '../input-text/en/pers_page';

class PressKit extends React.Component {
  constructor(props) {
    super(props);
    Categories._5.subcategories[0].logoBanners[0].logoImg = logoSvgHorizontal;
    Categories._5.subcategories[0].logoBanners[0].description = 'aircheckr logo horizontaal<br/>' +
      '(<a href="' + logoSvgHorizontal + '" target="_blank">svg</a> | ' +
      '<a href="' + logo300Horizontal + '" target="_blank">png_300dpi</a> | ' +
      '<a href="' + logo144Horizontal + '" target="_blank">png_144dpi</a>)<br /> ' +
      'aircheckr logo horizontaal met witte tekst<br />' +
      '(<a href="' + logo144HorizontalNegative + '" target="_blank">png_144dpi</a>)';
    Categories._5.subcategories[0].logoBanners[1].logoImg = logoSvgSquare;
    Categories._5.subcategories[0].logoBanners[1].description = 'aircheckr logo vierkant<br/>' +
      '(<a href="' + logoSvgSquare + '" target="_blank">svg</a> | ' +
      '<a href="' + logo300Square + '" target="_blank">png_300dpi</a>)';
    Categories._5.subcategories[0].logoBanners[2].logoImg = logoSvgpicto;
    Categories._5.subcategories[0].logoBanners[2].description = 'aircheckr logo pictogram<br/>' +
      '(<a href="' + logoSvgpicto + '" target="_blank">svg</a> | ' +
      '<a href="' + logo300picto + '" target="_blank">png_300dpi</a><!-- | ' +
      '<a href="' + logo144picto + '" target="_blank">png_144dpi</a>-->)';
    Categories._6.subcategories[0].logoBanners[0].logoImg = nazkaTeamOneThumb;
    Categories._6.subcategories[0].logoBanners[0].description = 'aircheckr team<br/>' +
      '(<a href="' + nazkaTeamOne + '" target="_blank">jpeg_300dpi</a>)';
    Categories._6.subcategories[0].logoBanners[1].logoImg = nazkaTeamTwoThumb;
    Categories._6.subcategories[0].logoBanners[1].description = 'the founders<br/>' +
      '(<a href="' + nazkaTeamTwo + '" target="_blank">jpeg_300dpi</a>)';
    Categories._6.subcategories[0].logoBanners[2].logoImg = aircheckrOnPhoneThumb;
    Categories._6.subcategories[0].logoBanners[2].description = 'aircheckr op mobiele telefoon<br/>' +
      '(<a href="' + aircheckrOnPhone + '" target="_blank">png_300dpi</a>)';
    Categories._6.subcategories[0].logoBanners[3].logoImg = aircheckrWidgetThumb;
    Categories._6.subcategories[0].logoBanners[3].description = 'aircheckr widget<br/>' +
      '(<a href="' + aircheckrWidget300 + '" target="_blank">png_300dpi</a> | ' +
      '<a href="' + aircheckrWidget96 + '" target="_blank">png_96dpi</a>)';
  }

  render(){
    return (
      <div>
        <SimpleContainer color='dark' containerClass='header-container padded-container' backgroundImage={ backgroundImage }>
          <div className='col-sm-offset-4 col-sm-8 header-info'>
            <h1>{PageText._1}</h1>
            <p dangerouslySetInnerHTML={{ __html: PageText._2 }}></p>
          </div>
        </SimpleContainer>
        <CategoryContainer cols='1' category={ Categories._1 } />
        <CategoryContainer cols='1' category={ Categories._2 } />
        <CategoryContainer cols='1' category={ Categories._3 } />
        <CategoryContainer cols='1' category={ Categories._4 } />
        <CategoryContainer cols='1' category={ Categories._5 } />
        <CategoryContainer cols='1' category={ Categories._6 } />
      </div>
    );
  }
};

export default PressKit;



// WEBPACK FOOTER //
// ./src/routes/Pers.js